import LayoutExterno from '~componentes/LayoutExterno.vue';
import LiberarCancelarSolicitacao from './componentes/LiberarCancelarSolicitacao.vue';

export default {
  path: '/liberar-solicitacao/:id/:coordenador',
  component: LayoutExterno,
  children: [
    {
      name: 'liberar-solicitacao.compra',
      path: 'compra',
      component: LiberarCancelarSolicitacao
    },
    {
      name: 'liberar-solicitacao.pagamento',
      path: 'pagamento',
      component: LiberarCancelarSolicitacao
    },
    {
      name: 'liberar-solicitacao.reembolso',
      path: 'reembolso',
      component: LiberarCancelarSolicitacao
    },
    {
      name: 'liberar-solicitacao.faturamento',
      path: 'faturamento',
      component: LiberarCancelarSolicitacao
    },
    {
      name: 'liberar-solicitacao.faturamento-multiservico',
      path: 'faturamento-multiservico',
      component: LiberarCancelarSolicitacao
    },
    {
      name: 'liberar-solicitacao.bolsa',
      path: 'bolsa',
      component: LiberarCancelarSolicitacao
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/liberar-cancelar-solicitacao/rotas-liberar.js